module.exports = __webpack_public_path__ + "img/icon_xcx.2fe7031a.png";